export default {
    "template": "componentsCompany/level/CompanySettings",
    "default_number_format": {
        "decimal_point": ",",
        "decimal_length": 2
    },
    "menu_template": "componentsCompany/level/header/MenuComponent"
}